module.exports = __webpack_public_path__ + "static/img/img_guide.6148246c.png";